// Module
var code = `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 48 48"><path d="M9 21h12V9H9zM27 9v12h12V9zM9 39h12V27H9zm18 0h12V27H27z"></path></svg>`;
// Exports
export default code;